import { mediaQueryWidth } from '@core/styles/helpers'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Checkbox, Skeleton, Spin } from 'antd'
import { rgba } from 'polished'

export const StyledTableHead = styled('div', {
  shouldForwardProp: (prop) => prop !== 'configTheme'
})`
  background: ${({ configTheme, theme }) =>
    configTheme && configTheme.activeColorCode
      ? configTheme?.activeColorCode
      : theme.table.headerBg};

  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
`

export const StyledTableRow = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  transition: background 0.5s ease;

  &[role='row'] {
    border-bottom: 1px solid ${({ theme }) => theme.common.borderColor};
  }

  cursor: ${({ rowHover }) => (rowHover ? 'pointer' : 'inherit')};

  :hover {
    background: ${({ rowHover, theme }) =>
      rowHover ? theme.table.rowHover : 'inherit'};
  }
`

export const StyledTable = styled.div`
  width: 100%;

  overflow-x: auto;

  ${StyledTableHead}, ${StyledTableRow} {
    min-width: ${({ minWidth }) => minWidth};
  }
`

export const StyledCell = styled('div', {
  shouldForwardProp: (prop) =>
    !['color', 'width', 'type', 'configTheme'].includes(prop)
})`
  flex: ${({ width }) => (typeof width === 'number' ? width : 0)} 0 auto;
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
  text-align: ${({ alignment }) => alignment};

  margin-left: 12px;
  font-size: 17px;
  font-weight: 300;

  .ant-typography {
    margin-bottom: 0;
  }

  ${({ type, configTheme, theme }) =>
    type === 'header' &&
    css`
      font-weight: 400;
      color: ${configTheme && configTheme.activeColorCode
        ? 'white'
        : theme.table.headerColor};
    `};
`

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledCheckBox = styled(Checkbox)`
  cursor: pointer;
`

export const MenuIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;

  border-radius: 8px;

  svg,
  & {
    cursor: pointer;
  }

  :hover {
    transition: all 0.25s ease;
    background: ${rgba('#b8bfc9', 0.3)};
  }
`

export const MenuLinkWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`

export const MenuLink = styled('a', {
  shouldForwardProp: (prop) => prop !== 'configTheme'
})`
  display: flex;
  cursor: pointer;
  font-weight: 400;

  color: ${({ configTheme, theme }) =>
    configTheme && configTheme.activeColorCode
      ? configTheme?.activeColorCode
      : theme.table.menuLinkColor};

  :hover {
    color: ${({ configTheme, theme }) =>
      configTheme && configTheme.activeColorCode
        ? configTheme?.activeColorCode
        : theme.table.menuLinkColor};
  }

  .ess-icon {
    svg {
      cursor: pointer;

      * {
        fill: ${({ configTheme, theme }) =>
          configTheme && configTheme.activeColorCode
            ? configTheme?.activeColorCode
            : theme.table.menuLinkColor};
      }
    }
  }
`

export const StyledRowGroup = styled.div`
  ${mediaQueryWidth('md')} {
    height: ${({ maxHeight }) => maxHeight};
  }
`

export const LoadingWrapper = styled.div`
  padding: 10px;

  ${mediaQueryWidth('md')} {
    display: flex;
    justify-content: center;
    padding: 40px;
  }
`

export const DesktopSpinner = styled(Spin)`
  display: none;

  ${mediaQueryWidth('md')} {
    display: block;
  }
`

export const MobileSkeleton = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== 'minWidth'
})`
  display: table;
  min-width: ${({ minWidth }) => minWidth};

  ${mediaQueryWidth('md')} {
    display: none;
  }
`
